import { Popover } from "@base-ui/react/popover"
import classNames from "classnames"
import PropTypes from "prop-types"
import React from "react"

function parsePlacement(placement) {
  if (!placement || placement === "auto") {
    return { side: "top", align: "center" }
  }
  const parts = placement.split("-")
  return {
    side: parts[0],
    align: parts[1] || "center",
  }
}

const ARROW_CLASSES = [
  "flex",
  "data-[side=bottom]:-top-2 data-[side=bottom]:rotate-0",
  "data-[side=left]:right-[-13px] data-[side=left]:rotate-90",
  "data-[side=right]:left-[-13px] data-[side=right]:-rotate-90",
  "data-[side=top]:-bottom-2 data-[side=top]:rotate-180",
].join(" ")

const ArrowSvg = ({ variant }) => (
  <svg width="20" height="10" viewBox="0 0 20 10" fill="none">
    <path
      d="M9.66437 2.60207L4.80758 6.97318C4.07308 7.63423 3.11989 8 2.13172 8H0V10H20V8H18.5349C17.5468 8 16.5936 7.63423 15.8591 6.97318L11.0023 2.60207C10.622 2.2598 10.0447 2.25979 9.66437 2.60207Z"
      className={variant === "dark" ? "fill-gray-800" : "fill-white"}
    />
    {variant === "light" && (
      <path
        d="M10.3333 3.34539L5.47654 7.71648C4.55842 8.54279 3.36693 9 2.13172 9H0V8H2.13172C3.11989 8 4.07308 7.63423 4.80758 6.97318L9.66437 2.60207C10.0447 2.25979 10.622 2.2598 11.0023 2.60207L15.8591 6.97318C16.5936 7.63423 17.5468 8 18.5349 8H20V9H18.5349C17.2998 9 16.1083 8.54278 15.1901 7.71648L10.3333 3.34539Z"
        className="fill-gray-200"
      />
    )}
  </svg>
)

ArrowSvg.propTypes = {
  variant: PropTypes.oneOf(["light", "dark"]).isRequired,
}

const Tooltip = ({
  children,
  text,
  placement = "auto",
  variant = "light",
  maxWidth,
  textCenter = false,
  tabIndex,
}) => {
  const { side, align } = parsePlacement(placement)

  const popupClasses = classNames(
    "z-50 whitespace-pre-wrap rounded p-3 pointer-events-none",
    {
      "bg-gray-800 text-white": variant === "dark",
      "bg-white text-gray-900 shadow-md border": variant === "light",
      "text-center": textCenter,
    }
  )

  return (
    <Popover.Root>
      <Popover.Trigger
        openOnHover
        render={<div className="inline-block w-fit" tabIndex={tabIndex} />}
        nativeButton={false}
        delay={0}
      >
        {children}
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Positioner side={side} align={align} sideOffset={8}>
          <Popover.Popup
            className={popupClasses}
            style={maxWidth ? { maxWidth } : undefined}
          >
            {text}
            <Popover.Arrow className={ARROW_CLASSES}>
              <ArrowSvg variant={variant} />
            </Popover.Arrow>
          </Popover.Popup>
        </Popover.Positioner>
      </Popover.Portal>
    </Popover.Root>
  )
}

Tooltip.propTypes = {
  children: PropTypes.node.isRequired,
  maxWidth: PropTypes.string,
  placement: PropTypes.oneOf([
    "auto",
    "top",
    "bottom",
    "left",
    "right",
    "top-start",
    "top-end",
    "right-start",
    "right-end",
    "bottom-start",
    "bottom-end",
    "left-start",
    "left-end",
  ]),
  text: PropTypes.node.isRequired,
  tabIndex: PropTypes.number,
  textCenter: PropTypes.bool,
  variant: PropTypes.oneOf(["light", "dark"]),
}

export default Tooltip
